import React from 'react';
import {connect} from 'react-redux';
import {dialogClose} from '../actions/creators/dialogs'
import Dialog from './Dialog';

export interface DialogProps {
    id?: string,
    emoji?: string,
    icon?: string,
    buttons?: {
        label: string,
        onClick: Function,
        primary?: boolean,
    }[],
    message: string,
    easyClose?: boolean,
};

type Props = {
    dialogs: {
        [key: string]: DialogProps,
    },
    dialogClose: Function,
};

class Dialogs extends React.Component<Props> {
    constructor(props) {
        super(props);

        this.bgClick = this.bgClick.bind(this);
    }

    bgClick() {
        const { dialogs } = this.props;
        const ids = Object.keys(dialogs);
        const lastDialog = dialogs[ids[ids.length - 1]];

        if (lastDialog.easyClose) {
            this.props.dialogClose(lastDialog.id);
        }
    }

    render() {
        const ids = Object.keys(this.props.dialogs);
        if (!ids.length) {
            return '';
        }

        // @todo Fix block z index

        return ids.map(id => <Dialog key={id} onBgClick={this.bgClick} dialog={this.props.dialogs[id]} />);
    }
}

const mapStateToProps = ({ dialogs }) => ({
    dialogs
});

const mapDispatchToProps = {
    dialogClose
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(Dialogs);